<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <div class="d-flex align-items-center">
        <span @click="$router.go(-1)">
          <b-button
            variant="white"
            class="btn-icon rounded-circle mr-50 text-primary bg-white"
            size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span>
        <h2 class="font-weight-bolder m-0 mr-2">Notificaciones</h2>
      </div>
      <b-button variant="primary" @click="addNotify" class="ml-2">
        Añadir notificación
      </b-button>
    </div>
    <b-card class="mb-2 p-2">
      <div class="mb-2">
        <p><strong>Indica las notificaciones que recibirá el trabajador en su aplicación.</strong></p>
        <p class="text-muted small mb-2">Esta notificación sólo se recibirá en los usuarios con la jornada en progreso.</p>
      </div>
      <b-row>
        <b-col cols="12">
          <transition-group name="fade" tag="div">
            <b-card
              v-for="(notify, index) in notifications"
              :key="index"
              class="mb-2 notification-card border shadow-sm"
            >
              <div class="d-flex align-items-center justify-content-between mb-2 notification-header">
                <div class="d-flex align-items-center flex-grow-1">
                  <feather-icon icon="BellIcon" class="text-primary mr-1" size="18" />
                  <span class="font-weight-bold mr-2">Notificación {{ index + 1 }}</span>
                </div>
                <div class="d-flex align-items-start mr-2">
                  <b-form-select
                    v-model="notify.type"
                    :options="notificationTypes"
                    class="mr-2"
                    style="width: auto;"
                  />
                  <div class="d-flex flex-column">
                    <b-form-timepicker
                      v-model="notify.hour"
                      locale="es"
                      :no-close-button="true"
                      :hide-header="true"
                      :minutes-step="5"
                    />
                    <small v-if="notify.type !== 'fixed'" class="text-muted mt-1">
                      {{ notify.type === 'start' ? 'Tiempo tras inicio de jornada' : 'Tiempo tras fin de jornada' }}
                    </small>
                  </div>
                </div>
                <b-button
                  variant="link"
                  class="p-0 text-danger remove-btn ml-2"
                  @click="removeNotify(index)"
                  title="Eliminar notificación"
                >
                  <feather-icon icon="TrashIcon" size="18" />
                </b-button>
              </div>
              <b-row>
                <b-col sm="4">
                  <b-form-group label="Título" label-for="notify-title">
                    <b-form-input v-model="notify.title" name="title" placeholder="Título" />
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group label="Texto" label-for="notify-body">
                    <b-form-input v-model="notify.body" name="body" placeholder="Texto de la notificación" />
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group label="Horario" label-for="notify-work_schedule">
                    <BaseSelect
                        v-model="notify.work_schedule"
                        :searchable="true"
                        :clearable="true"
                        :multiple="false"
                        :httpBody="{
                          client_id: currentClient.id,
                          is_active: true,
                        }"
                            :resource="'/work-schedules'"
                        />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </transition-group>
        </b-col>
        <b-col cols="12" class="text-right mt-2">
          <b-button
            type="submit"
            variant="primary"
            class="mt-1 px-4"
            @click="saveNotifications"
          >
             Guardar
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BRow, BCol, BCard, BFormGroup, BFormTimepicker, BFormInput, BFormSelect,
} from 'bootstrap-vue'

import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  components: {
    BaseSelect,
    BButton,
    BRow,
    BCol,
    BCard,
    BFormGroup,
    BFormTimepicker,
    BFormInput,
    BFormSelect,
  },
  computed: {
    ...mapGetters({
      calendar: 'calendar/getConfigCalendar',
      currentClient: 'clients/getCurrentClient',
    }),
  },
  data() {
    return {
      notifications: [],
      notificationTypes: [
        { value: 'fixed', text: 'Hora fija' },
        { value: 'start', text: 'Tras inicio jornada' },
        { value: 'end', text: 'Tras fin jornada' },
      ],
    }
  },
  watch: {
    notifications: {
      handler(newNotifications) {
        newNotifications.forEach(notify => {
          // Observar cambios en el tipo de cada notificación
          if (notify.lastType && notify.lastType !== notify.type) {
            this.$set(notify, 'hour', '00:00:00')
          }
          this.$set(notify, 'lastType', notify.type)
        })
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      editCalendar: 'calendar/edit',
      getCalendar: 'calendar/getConfigCalendar',
    }),
    addNotify() {
      this.notifications.push({
        hour: '00:00:00',
        title: '',
        body: '',
        work_schedule: '',
        type: 'fixed',
      })
    },
    removeNotify(index) {
      this.notifications.splice(index, 1)
    },
    loadNotifications() {
      if (this.calendar.notifications_push) {
        try {
          const arr = JSON.parse(this.calendar.notifications_push)
          this.notifications = arr.map(n => {
            const notification = typeof n === 'string' ? JSON.parse(n) : n
            return {
              ...notification,
              type: notification.type || 'fixed',
            }
          })
        } catch (e) {
          this.notifications = []
        }
      }
    },
    async saveNotifications() {
      const data = new FormData()
      // Mapear notificaciones para enviar {id, name} del work_schedule
      const notificationsToSend = this.notifications.map(notify => ({
        ...notify,
        work_schedule: typeof notify.work_schedule === 'object' && notify.work_schedule !== null
          ? { id: notify.work_schedule.id, name: notify.work_schedule.name }
          : notify.work_schedule,
      }))
      data.append('notifications_push', JSON.stringify(notificationsToSend))
      data.append('client_id', this.currentClient.id)
      await this.editCalendar({ calendar: data })
    },
  },
  async created() {
    await this.getCalendar(this.currentClient.id)
    this.loadNotifications()
  },
}
</script>

<style scoped>
.notification-header {
  gap: 0.5rem;
}
.notification-card {
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  border: 1.5px solid #e3e7ed;
  background: #fff;
  transition: box-shadow 0.2s, border-color 0.2s;
}
.notification-card:hover {
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  border-color: #b3c2db;
}
.remove-btn {
  transition: color 0.2s;
}
.remove-btn:hover {
  color: #d9534f !important;
}
.fade-enter-active, .fade-leave-active {
  transition: all 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
